import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useIntl } from "react-intl";
import { editTheme, getTheme } from "store/actions";
import Loader from "components/shared/loader";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import CreatableReactSelect from "components/Form/creatable-react-select";
import SaveChangesButton from "components/Form/save-changes-button";
import FormWrapper from "components/Form/form-wrapper";
import { getAllCategories } from "store/categories/actions";
import Form from "components/Form";
import Input from "components/Form/input";
import Textarea from "components/Form/textarea/index";
import ReactSelect from "components/Form/react-select";
import ImageUpload from "components/Form/image-upload";
import { cutImageFullPath, handleErrMsg } from "helpers/functions";
import ImagesUpload from "components/Form/images-upload";

const EditTheme = () => {
    const { formatMessage, locale } = useIntl();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id } = useParams();
    const { loading, error, singleTheme } = useSelector(
        (state) => state.themes
    );
    const { categories } = useSelector((state) => state.categories);

    const [images, setImages] = useState([]);
    const [editAppInfoCheck, setEditAppInfoCheck] = useState(false);
    // const [formObject, setFormObject] = useState({});
    useEffect(() => {
        setImages(singleTheme?.images || []);
        // setFormObject(singleTheme?.settingsFormObject || []);
    }, [singleTheme]);

    useEffect(() => {
        dispatch(getTheme(id));
        dispatch(getAllCategories());
    }, [dispatch, id]);

    let resetValues = {
        ...singleTheme,
        category: singleTheme?.category?.id,
    };

    useEffect(() => {
        if (Object.keys(error)?.length > 0) {
            toastErrorMessage(
                formatMessage({ id: handleErrMsg(error) }),
                locale
            );
        }
    }, [error, formatMessage, locale, navigate]);

    const onSubmit = (data) => {
        cutImageFullPath(data?.icon);
        data.images = images;

        dispatch(editTheme({ id, data }));
        setEditAppInfoCheck(!editAppInfoCheck);
    };

    if (loading) return <Loader />;

    return (
        <FormWrapper title={"editTheme"}>
            <Form onSubmit={onSubmit} defaultValues={resetValues}>
                <ImageUpload name="icon" langId={false} rules={{}} />

                <Input name="name" locale="ar" langId="themeName" />
                <Input name="name" locale="en" langId="themeName" />
                <ImagesUpload
                    imagesURLs={images}
                    setImageURLs={setImages}
                    langId="screenShots"
                />
                <Textarea name="description" locale="ar" langId="description" />
                <Textarea name="description" locale="en" langId="description" />

                <CreatableReactSelect
                    name="tags"
                    placeholder="addTag"
                    lg={"12"}
                />
                <ReactSelect name="category" options={categories} lg={12} />

                <Input name="link" langId="appLink" />
                <Input name="supportEmail" langId="supportEmail" />

                <SaveChangesButton />
            </Form>
        </FormWrapper>
    );
};

export default EditTheme;
